import { OrderContentData } from "../orders/orderContentData";
import { OrderContent } from "../orders/orderContent";

export class UploadDocument {
    public IsSelected: boolean;
    public Data: OrderContent;

    public constructor(init?:Partial<UploadDocument>) {
        Object.assign(this, init);
    }
}



// WEBPACK FOOTER //
// ./app/objects/documnets/uploadDocumnet.ts